<template>
<div>
    <b-alert v-for="(message, indx) in messages" :key="indx" :show="message.counter" dismissible :variant="message.type">
        {{ message.message }}
    </b-alert>
</div>
</template>

<script>

import { bus } from "../main"; 

export default {
    name: "message",
    data() {
        return {
            messages: [
                /*
                {
                    type: "primary",
                    message: "ALARM,ALARM dies ist ein Alarm!",
                    countdown: 3,
                    counter: 3
                },
                {
                    type: "success",
                    message: "Immer locker bleiben .. ",
                    countdown: 4,
                    counter: 4
                },
                {
                    type: "danger",
                    message: "error errror Immer locker bleiben .. ",
                    countdown: 30,
                    counter:30
                }
                */
            ]
        };
    },
    methods: {
        pushSuccess: function(msg) {
            console.log('reaching successs..')
            this.messages.push({
                type: "success",
                message: msg,
                countdown: 8,
                counter: 8
            });
        },
        pushMessage: function(msg) {
            this.messages.push({
                type: "primary",
                message: msg,
                countdown: 8,
                counter: 8
            });
        },
        pushError: function(msg) {
            this.messages.push({
                type: "danger",
                message: msg,
                countdown: 30,
                counter: 30
            });
        },
        countDownChanged(message) {
            message.counter--;
        }
  },
  mounted() {
    /* keine Messages gewünscht:  http://redmine.tsmtreuhand.ch:32770/issues/633 */
    bus.$on("success", this.pushSuccess);
    bus.$on("message", this.pushMessage);
    bus.$on("error", this.pushError);
  }
};
</script>